import poliApiGatewayRequest from 'src/utils/poliApiGatewayRequest';

export class BotsService {
  static mountFilters(filters: any) {
    return `?filters=${JSON.stringify(filters)}`;
  }

  static async getBotFlow(token: string, customer_id: number) {
    //   buscar fluxos que iniciam com ACTION_ON_CHAT e que estejam ativos
    const url = `/spa/automatic-action/v2/flows${this.mountFilters({
      and: {
        start_action: 'ACTION_ON_CHAT',
        status: 1,
      },
    })}`;
    const response = await poliApiGatewayRequest.get(url, {
      headers: {
        'x-poli-customer-id': customer_id,
      },
    });
    return response.data;
  }
}
